<template>
  <NuxtLayout>
    <NuxtLoadingIndicator color="#0abf53" />
    <NuxtPage />
  </NuxtLayout>
</template>
